export const OUTBOUND_CALL = 'outbound-call';
export const INBOUND_CALL = 'inbound-call';
export const EMAIL_SENT = 'email-sent';
export const EMAIL_RECEIVED = 'email-received';
export const MEETING = 'meeting';
export const OTHER = 'other';
export const FOLLOW_UP_NEEDED = 'follow-up-needed';
export const IN_PROGRESS = 'in-progress';
